"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var StyledCheckoutSummary = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var CheckoutSummary = function (props) {
  var cart = props.cart,
    onClick = props.onClick,
    disabled = props.disabled,
    _a = props.buttonLabel,
    buttonLabel = _a === void 0 ? '下一步' : _a;
  return react_1.default.createElement(StyledCheckoutSummary, null, react_1.default.createElement(antd_1.Divider, {
    orientation: "center"
  }, "\u91D1\u984D\u8CC7\u8A0A"), react_1.default.createElement(antd_1.List, {
    header: react_1.default.createElement(antd_1.Row, {
      justify: "space-between"
    }, react_1.default.createElement("h4", null, "\u5C0F\u8A08"), react_1.default.createElement("h4", null, "$", cart.subtotal)),
    size: "small",
    bordered: true,
    dataSource: __spreadArray(__spreadArray([], cart.extra_items.map(function (i) {
      return __assign(__assign({}, i), {
        type: 'extra'
      });
    })), cart.discount_items.map(function (i) {
      return __assign(__assign({}, i), {
        type: 'discount'
      });
    })),
    renderItem: function (i) {
      return react_1.default.createElement(react_1.Fragment, null, i.type === 'extra' && react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(antd_1.List.Item, null, react_1.default.createElement("h4", null, i.name), react_1.default.createElement("h4", null, "$", i.amount))), i.type === 'discount' && react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(antd_1.List.Item, null, react_1.default.createElement("h4", {
        style: {
          color: 'red'
        }
      }, i.name), react_1.default.createElement("h4", {
        style: {
          color: 'red'
        }
      }, "-$", i.amount))));
    },
    footer: react_1.default.createElement(antd_1.Row, {
      justify: "space-between"
    }, react_1.default.createElement("h2", null, "\u7E3D\u91D1\u984D"), react_1.default.createElement("h2", null, "$", cart.total))
  }), react_1.default.createElement(antd_1.Button, {
    size: "large",
    type: "primary",
    disabled: disabled,
    onClick: onClick,
    style: {
      marginTop: 10,
      width: '100%'
    }
  }, buttonLabel));
};
exports.default = CheckoutSummary;
var templateObject_1;